export { WorkspaceQuotaService } from './services/quota';
export { QuotaCheck } from './views/quota-check';

import {
  type Framework,
  WorkspaceScope,
  WorkspaceService,
} from '@toeverything/infra';

import { WorkspaceServerService } from '../cloud';
import { WorkspaceQuota } from './entities/quota';
import { WorkspaceQuotaService } from './services/quota';
import { WorkspaceQuotaStore } from './stores/quota';

export function configureQuotaModule(framework: Framework) {
  framework
    .scope(WorkspaceScope)
    .service(WorkspaceQuotaService)
    .store(WorkspaceQuotaStore, [WorkspaceServerService])
    .entity(WorkspaceQuota, [WorkspaceService, WorkspaceQuotaStore]);
}
